import React, { useEffect, useRef, useState } from 'react';
import { Popover } from '@mui/material';

function CustomPopover(props) {
  const { children, anchorEl, setAnchorEl, PaperProps = {}, ...rest } = props;
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const popoverAction = useRef(null);
  const [paperEl, setPaperEl] = useState(null);

  const handleClose = () => {
    setAnchorEl(null);
  };

  // popover content is often fetched after the popover opens (filter options, etc.).
  // MUI only positions the paper when the Popover itself re-renders, so a paper that
  // grows afterwards keeps its original top and spills out of the viewport on short
  // screens. Re-run the positioning whenever the paper resizes.
  useEffect(() => {
    if (!paperEl || typeof ResizeObserver === 'undefined') return undefined;

    const observer = new ResizeObserver(() => {
      popoverAction.current?.updatePosition();
    });

    observer.observe(paperEl);

    return () => observer.disconnect();
  }, [paperEl]);

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      {...rest}
      action={popoverAction}
      PaperProps={{ ...PaperProps, ref: setPaperEl }}
    >
      {children}
    </Popover>
  );
}

export default CustomPopover;
